import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "pswp__scroll-wrap" }
const _hoisted_3 = { class: "pswp__ui pswp__ui--hidden" }
const _hoisted_4 = { class: "pswp__top-bar" }
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]
const _hoisted_7 = ["title"]
const _hoisted_8 = ["title"]
const _hoisted_9 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "photo-swipe-gallery | pswp",
    ref: "mainFullScreenGallery",
    id: _ctx.id,
    tabindex: "-1",
    role: "dialog",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", {
      class: "pswp__bg",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeZoom && _ctx.closeZoom(...args)))
    }),
    _cache[18] || (_cache[18] = _createTextVNode()),
    _createElementVNode("div", _hoisted_2, [
      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "pswp__container" }, [
        _createElementVNode("div", { class: "pswp__item" }),
        _createTextVNode(),
        _createElementVNode("div", { class: "pswp__item" }),
        _createTextVNode(),
        _createElementVNode("div", { class: "pswp__item" })
      ], -1 /* HOISTED */)),
      _cache[17] || (_cache[17] = _createTextVNode()),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "pswp__counter" }, null, -1 /* HOISTED */)),
          _cache[3] || (_cache[3] = _createTextVNode()),
          _createElementVNode("button", {
            class: "pswp__button pswp__button--fs",
            title: _ctx.$t('photoSwipe.toggle')
          }, null, 8 /* PROPS */, _hoisted_5),
          _cache[4] || (_cache[4] = _createTextVNode()),
          _createElementVNode("button", {
            class: "pswp__button pswp__button--zoom",
            title: _ctx.$t('photoSwipe.zoom')
          }, null, 8 /* PROPS */, _hoisted_6),
          _cache[5] || (_cache[5] = _createTextVNode()),
          _cache[6] || (_cache[6] = _createElementVNode("button", {
            class: "pswp__button pswp__button--share",
            title: "Share"
          }, null, -1 /* HOISTED */)),
          _cache[7] || (_cache[7] = _createTextVNode()),
          _createElementVNode("button", {
            class: "pswp__button pswp__button--close",
            title: _ctx.$t('photoSwipe.close'),
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeZoom && _ctx.closeZoom(...args)))
          }, null, 8 /* PROPS */, _hoisted_7),
          _cache[8] || (_cache[8] = _createTextVNode()),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "pswp__preloader" }, [
            _createElementVNode("div", { class: "pswp__preloader__icn" }, [
              _createElementVNode("div", { class: "pswp__preloader__cut" }, [
                _createElementVNode("div", { class: "pswp__preloader__donut" })
              ])
            ])
          ], -1 /* HOISTED */))
        ]),
        _cache[10] || (_cache[10] = _createTextVNode()),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "pswp__share-modal pswp__share-modal--hidden pswp__single-tap" }, [
          _createElementVNode("div", { class: "pswp__share-tooltip" })
        ], -1 /* HOISTED */)),
        _cache[12] || (_cache[12] = _createTextVNode()),
        _createElementVNode("button", {
          class: "pswp__button pswp__button--arrow pswp__button--arrow--left",
          title: _ctx.$t('photoSwipe.arrowLeft')
        }, null, 8 /* PROPS */, _hoisted_8),
        _cache[13] || (_cache[13] = _createTextVNode()),
        _createElementVNode("button", {
          class: "pswp__button pswp__button--arrow pswp__button--arrow--right",
          title: _ctx.$t('photoSwipe.arrowRight')
        }, null, 8 /* PROPS */, _hoisted_9),
        _cache[14] || (_cache[14] = _createTextVNode()),
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "pswp__caption" }, [
          _createElementVNode("div", { class: "pswp__caption__center" })
        ], -1 /* HOISTED */))
      ])
    ])
  ], 8 /* PROPS */, _hoisted_1))
}